import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, EmailAddresses, EmailAddress } from '@/models/EmailAddress.model';

// Inital state
const state: EmailAddresses = {
  emailAddresses: [],
  emailTypes: [],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, EmailAddresses> = {
  emailAddresses: (state) => state.emailAddresses,
  emailTypes: (state) => state.emailTypes,

  emailAddressesByCustomer: (state) => (customerId: number): EmailAddress[] => {
    return state.emailAddresses.filter((item: EmailAddress) => {
      return item.customerId === customerId;
    });
  },
};

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, EmailAddresses> = {
  setEmailAddresses(state, { emailAddresses }) {
    state.emailAddresses = emailAddresses;
  },

  setEmailTypes(state, { emailTypes }) {
    state.emailTypes = emailTypes;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, EmailAddresses, Mutations, Getters> = {
  setEmailAddresses({ commit }, payload) {
    commit('setEmailAddresses', payload);
  },

  setEmailTypes({ commit }, payload) {
    commit('setEmailTypes', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<EmailAddresses, Getters, Mutations, Actions>('EmailAddressModule');

export const EmailAddressModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
